/* src/components/landing/LpPricing.jsx */
import React from 'react';
import { Link } from 'react-router-dom';
import { PRICING } from '../../data/landing';

export default function LpPricing({ addReveal, revealStyle, isAnnual, setIsAnnual, btnPrimary, btnOutline, btnDark }) {
  return (
    <section id="precos" className="s-pad" style={{ padding: '120px 0' }}>
      <div className="container">

        {/* Header */}
        <div ref={addReveal} style={{ ...revealStyle, textAlign: 'center', maxWidth: 600, margin: '0 auto 64px' }}>
          <span className="section-label">Planos</span>
          <h2 className="serif s-title" style={{ fontSize: '2.8rem', marginBottom: 16 }}>Escolha o plano ideal para seu negócio</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem' }}>Comece grátis e escale conforme cresce. Cancele quando quiser.</p>
        </div>

        {/* Toggle */}
        <div ref={addReveal} style={{ ...revealStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 48 }}>
          <span style={{ fontSize: '0.9rem', fontWeight: 500, color: !isAnnual ? 'var(--primary)' : 'var(--text-muted)' }}>Mensal</span>
          <div onClick={() => setIsAnnual(!isAnnual)} style={{ width: 48, height: 26, borderRadius: 13, background: 'var(--accent)', position: 'relative', cursor: 'pointer' }}>
            <div style={{ position: 'absolute', top: 3, left: isAnnual ? 25 : 3, width: 20, height: 20, borderRadius: '50%', background: '#fff', transition: 'left 0.3s', boxShadow: '0 1px 4px rgba(0,0,0,0.15)' }} />
          </div>
          <span style={{ fontSize: '0.9rem', fontWeight: 500, color: isAnnual ? 'var(--primary)' : 'var(--text-muted)' }}>Anual</span>
          <span style={{ background: 'rgba(0,214,143,0.1)', color: 'var(--accent)', fontSize: '0.75rem', fontWeight: 700, padding: '3px 10px', borderRadius: 100 }}>-20%</span>
        </div>

        {/* Cards */}
        <div className="pricing-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24, maxWidth: 1000, margin: '0 auto' }}>
          {PRICING.map((p, i) => {
            const btnS = p.btnStyle === 'primary' ? btnPrimary : p.btnStyle === 'dark' ? btnDark : btnOutline;
            return (
              <div key={i} ref={addReveal} style={{ ...revealStyle, transitionDelay: `${0.1 * (i + 1)}s`, background: '#fff', border: p.popular ? '1.5px solid var(--accent)' : '1.5px solid var(--border)', borderRadius: 'var(--radius)', padding: '36px 30px', position: 'relative', boxShadow: p.popular ? '0 16px 48px rgba(0,214,143,0.1)' : 'none' }}>
                {p.popular && <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: 'var(--accent)', color: 'var(--primary)', fontSize: '0.7rem', fontWeight: 700, padding: '4px 16px', borderRadius: 100, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Mais popular</div>}
                <div style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 6 }}>{p.name}</div>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 24 }}>{p.desc}</div>
                {/* <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
                  <span style={{ fontSize: '1.2rem', fontWeight: 600, color: 'var(--text-muted)' }}>R$</span>
                  <span style={{ fontSize: '3rem', fontWeight: 700, lineHeight: 1, letterSpacing: '-0.03em' }}>{isAnnual ? p.annual : p.monthly}</span>
                </div> */}
                {/* <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 28 }}>/mês</div> */}
                <ul style={{ listStyle: 'none', marginBottom: 28 }}>
                  {p.features.map(f => (
                    <li key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '8px 0', fontSize: '0.88rem', color: 'var(--text-muted)' }}>
                      <span style={{ color: 'var(--accent)', fontWeight: 700, flexShrink: 0 }}>✓</span>{f}
                    </li>
                  ))}
                </ul>
                <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`}  target="_blank" rel="noopener noreferrer" style={{ ...btnS, width: '100%', textAlign: 'center' }}>Começar grátis</Link>
              </div>
            );
          })}
        </div>

        {/* API banner */}
        <div ref={addReveal} style={{ ...revealStyle, maxWidth: 1000, margin: '32px auto 0' }}>
          <div className="api-banner-inner" style={{ background: 'var(--surface)', border: '1.5px solid var(--border)', borderRadius: 'var(--radius)', padding: '28px 36px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ width: 44, height: 44, borderRadius: 10, background: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0 }}>{'{ }'}</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 2 }}>Só precisa da API?</div>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Contrate apenas o motor de cálculo via REST API. </div>
              </div>
            </div>
            <Link to="/api" style={{ ...btnPrimary, background: 'rgba(59,130,246,0.1)', color: '#3B82F6', padding: '10px 24px', fontSize: '0.85rem' }}>Ver documentação da API</Link>
          </div>
        </div>

      </div>
    </section>
  );
}
